import styled, { css } from 'styled-components';
import { getFontStyle } from '~components/Text/helper';
import { TooltipWeekendWorkProps } from '.';

export const Wrapper = styled.div<Omit<TooltipWeekendWorkProps, 'message'>>`
  position: absolute;
  display: inline-block;
  padding: 3px 4px 2px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
  color: #fff;
  white-space: nowrap;
  pointer-events: none;
  transition: left 0.3s, top 0.3s;
  ${getFontStyle('midium120_C1')};

  ${({ $x, $y, $opacity }) => css`
    opacity: ${$opacity};
    left: ${$x}px;
    top: ${$y}px;
  `}
`;
